module.exports = __webpack_public_path__ + "images/6830e67043c25abb09cb324fbe5b6651-Avalon.jpg";